import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { Base64 } from 'js-base64';


@Injectable({
  providedIn: 'root',
})
export class EstacionesService {
  private endpoint: string | null;

  constructor(private httpClient: HttpClient) {
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/catalogos/Estacion';
  }

  obtenerEstaciones(/*estacion: string*/) {
    return this.httpClient.get(
      this.endpoint + '/ObtenerEstacion' /* + estacion*/
    );
  }

  crearEstacion(EstacionRQ: any) {
    return this.httpClient.post(
      this.endpoint + '/InsertarEstacion',
      EstacionRQ
    );
  }

  actualizarEstacion(EstacionRQ: any) {
    return this.httpClient.post(this.endpoint + '/ModificarEstacion', EstacionRQ);
  }

  borrarEstacion(EstacionRQ: any) {
    return this.httpClient.post(this.endpoint + '/BorrarEstacion', EstacionRQ);
  }
}
